module.exports = __webpack_public_path__ + "static/media/contact.24c7e2af.svg";